module.exports = __webpack_public_path__ + "img/withdraw.7bcc240d.svg";